export default "__VITE_ASSET__GaCjUfgt__"